import React from "react";
import styled from "styled-components";
import SmallIcon from "../../Icons/SmallIcon/SmallIcon"

const IconButton = styled.button`
margin :${props => props.left ? "0 10px 0 0" : props.margin ? "0 0 0 5px" : ""};
padding:${props => props.padding ? `${props.padding}` : ""};
float:${props => props.right ? "right" : "left"};
background: ${props => props.primary ? "#ecf0f1" : props.success ? "#009b61" : props.black ? "#273e4c" : "white"};
border-radius: 6px;
border: none;
&:hover {
    background: ${props => props.primary ? "#dee2e3" : props.success ? "#1c7151" : props.black ? "#273e4c" : "#ecf0f1"};
    color: ${props => props.primary ? "#0e0f11" : props.success ? "white" : props.black ? "white" : "#0e0f11"};
  }
  &:focus {
	outline: none;
	box-shadow:${props => props.switch ? "none" : " 0px 0px 2px #009b61"};
}
`;

const ResumeButton = (props) => {


	return (
		<div  >
			<IconButton type='button' src={props.src} onClick={() => props.onClick()} {...props} >

			</IconButton>

			{props.title}
		</div>
	);
};
export default ResumeButton
